import React from "react";
import { QueryAvailableRadioEvents } from "../../../utils/graphql/hooks/radioHooks";

export default function RadioDataManager() {
  QueryAvailableRadioEvents();
  return <></>;
}
